@import 'src/global/media_queries'
  
:host 
  width: 100%
  display: block
  margin: 0.5rem 0

.countdown-wrapper
  width: 80%
  margin: 0 auto
  display: grid
  grid-template-columns: 1fr 1fr 1fr
  column-gap: 0.8rem

  .countdown-number-wrapper
    text-align: center
    display: grid
    grid-template-columns: 1fr 1fr
    grid-template-rows: 1fr auto
    grid-template-areas: 'numone numtwo' 'label label'
    gap: 0.2rem

    & :first-child
      grid-area: numone

    & :nth-child(2)
      grid-area: numtwo

    & :last-child
      grid-area: label

    .countdown-numbers
      width: 100%
      height: 2rem
      display: flex
      justify-content: center
      align-items: center
      font-size: var(--fs-l)
      font-weight: 900
      background-color: #fff
      border-radius: 0.3rem
      box-shadow: inset 0 0 0.3rem rgba(0,0,0,0.3)

      @include media(">tablet")
        font-size: var(--fs-m)

    span
      font-size: var(--fs-s)
      font-weight: 500

      @include media('>tablet')
        font-size: var(--fs-xs)
    